import { useCallback, useEffect, useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import getMyRecommendations from "../../apis/getMyRecommendations";
import removeRecommendationClient from "../../apis/removeRecommendationClient";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import BlockHeader from "../Headers/BlockHeader";
import { AlertInfo } from "../Alerts/Alert";
import FirmLogo from "../Images/FirmLogo";

const ClientRecommendation = () => {
  const { userDetails } = useAuthContext();
  const { user_slug, user_primary_role, user_id } = JSON.parse(userDetails);

  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [remark, setRemark] = useState("");

  const fetchRecommendations = useCallback(async () => {
    try {
      const res = await getMyRecommendations(user_slug);
      if (
        res?.data?.status === 1 &&
        Array.isArray(res?.data?.recommendations)
      ) {
        setRecommendations(res.data.recommendations);
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    } finally {
      setLoading(false);
    }
  }, [user_slug]);

  useEffect(() => {
    if (user_slug && user_primary_role === "4") {
      fetchRecommendations();
    }
  }, [user_slug, fetchRecommendations, user_primary_role]);

  const truncateText = (text, limit = 30) => {
    if (text.length <= limit) return text;
    return text.slice(0, limit) + "...";
  };

  const handleReadMore = (title, fullText) => {
    setModalTitle(title);
    setModalContent(fullText);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalContent("");
    setModalTitle("");
  };

  const openRemarkModal = (recommendationId) => {
    setSelectedRecommendation(recommendationId);
    setRemark("");
    setShowRemarkModal(true);
  };

  const submitRemoval = async () => {
    try {
      const res = await removeRecommendationClient(
        user_id,
        selectedRecommendation,
        remark
      );
      if (res?.data?.status === 1) {
        setRecommendations((prev) =>
          prev.filter((rec) => rec.recommendation_id !== selectedRecommendation)
        );
        setShowRemarkModal(false);
        Swal.fire("Deleted!", res?.data?.message, "success");
      } else {
        Swal.fire("Oops!", res?.data?.message, "error");
      }
    } catch (error) {
      console.error("Unable to remove recommendation:", error);
    }
  };

  return (
    <>
      {user_primary_role === "4" ? (
        <div className="row mt-4">
          <div className="col-12">
            <div className="card new-table-wrapper">
              <div className="card-body">
                <BlockHeader
                  title={"Network Recommendations"}
                  subText={"Candidates hand-selected by your network"}
                />
                {recommendations.length === 0 ? (
                  <AlertInfo message="No recommendations available!" />
                ) : (
                  <div className="table-responsive table-wrapper">
                    <table className="table table-bordered">
                      <thead className="no-border">
                        <tr className="border-top-0">
                          <th>Role</th>
                          <th>Firm</th>
                          <th>Selected by</th>
                          <th>Subject</th>
                          <th>Content</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recommendations.map((rec, index) => (
                          <tr key={index.toString()}>
                            <td className="align-middle">
                              <Link to={"resources/details/" + rec.user_slug}>
                                {rec.user_profile_role}
                              </Link>
                            </td>
                            <td className="align-middle">
                              <FirmLogo url={rec.firm_logo} />
                            </td>
                            <td className="align-middle">
                              {rec.resource_manager_name}
                            </td>
                            <td className="align-middle">
                              <span>
                                {rec.subject.length > 55 ? (
                                  <>
                                    {truncateText(rec.subject, 55)}
                                    {"..."}
                                  </>
                                ) : (
                                  rec.subject
                                )}
                              </span>
                            </td>
                            <td className="align-middle">
                              <span>
                                {rec.content.length > 55 ? (
                                  <>
                                    {truncateText(rec.content, 55)}
                                    {"..."}
                                  </>
                                ) : (
                                  rec.content
                                )}
                              </span>
                            </td>
                            <td className="align-middle">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  openRemarkModal(rec.recommendation_id)
                                }
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  // <div className="table-wrapper">
                  //   <div className="header-row flex-wrap">
                  //     <div className="col-custom">Role</div>
                  //     <div className="col-custom">Firm</div>
                  //     <div className="col-custom">Selected by</div>
                  //     <div className="col-custom" style={{ flex: "2 1 200px" }}>
                  //       Subject
                  //     </div>
                  //     <div className="col-custom" style={{ flex: "2 1 200px" }}>
                  //       Content
                  //     </div>
                  //     <div className="col-custom text-end">Actions</div>
                  //   </div>
                  //   {recommendations.map((rec) => (
                  //     <div
                  //       className="data-row flex-wrap"
                  //       key={rec.recommendation_id}
                  //     >
                  //       <div className="col-custom text-wrap">
                  //         <Link to={"resources/details/" + rec.user_slug}>
                  //           {rec.user_profile_role}
                  //         </Link>
                  //       </div>
                  //       <div className="col-custom">
                  //         <div
                  //           className="firm-logo-sm-custom"
                  //           alt={rec.firm_name}
                  //           style={{
                  //             backgroundImage: `url("${
                  //               FIRM_IMAGE_BASE + rec.firm_logo
                  //             }")`,
                  //             backgroundSize: "contain",
                  //             backgroundPosition: "center",
                  //             backgroundRepeat: "no-repeat",
                  //             width: "105px",
                  //             height: "30px",
                  //           }}
                  //         />
                  //       </div>
                  //       <div className="col-custom">
                  //         {rec.resource_manager_name}
                  //       </div>
                  //       <div
                  //         className="col-custom"
                  //         style={{ flex: "2 1 200px" }}
                  //       >
                  //         <span>
                  //           {rec.subject.length > 55 ? (
                  //             <>
                  //               {truncateText(rec.subject, 55)}
                  //               {"..."}
                  //             </>
                  //           ) : (
                  //             rec.subject
                  //           )}
                  //         </span>
                  //       </div>
                  //       <div
                  //         className="col-custom"
                  //         style={{ flex: "2 1 200px" }}
                  //       >
                  //         {rec.content.length > 60 ? (
                  //           <div className="d-block text-wrap pe-1">
                  //             <span>{truncateText(rec.content, 60)}</span>
                  //             <button
                  //               className="btn btn-link p-0 ms-1"
                  //               onClick={() =>
                  //                 handleReadMore("Content", rec.content)
                  //               }
                  //               style={{ fontSize: "0.9rem" }}
                  //             >
                  //               Read more
                  //             </button>
                  //           </div>
                  //         ) : (
                  //           rec.content
                  //         )}
                  //       </div>
                  //       <div className="col-custom text-end">
                  //         <button
                  //           className="btn btn-sm btn-danger"
                  //           onClick={() =>
                  //             openRemarkModal(rec.recommendation_id)
                  //           }
                  //         >
                  //           Remove
                  //         </button>
                  //       </div>
                  //     </div>
                  //   ))}
                  // </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* Read More Modal */}
      {showModal && (
        <div
          className="modal show fade"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex={-1}
          role="dialog"
          onClick={closeModal}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Full {modalTitle}</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <p style={{ textWrap: "wrap" }}>{modalContent}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Remark Modal */}
      {showRemarkModal && (
        <div
          className="modal show fade"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex={-1}
          role="dialog"
          onClick={() => setShowRemarkModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Remark for Removal</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowRemarkModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  placeholder="Enter your remark..."
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  rows={4}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowRemarkModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={submitRemoval}
                  disabled={!remark.trim()}
                >
                  Confirm Removal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ClientRecommendation;
